"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: "01",
  title: "Kuunteleminen",
  description: "Kartoitamme tarpeet, kohderyhmän ja ydinviestin. Selvitämme, miksi tämä sisältö on tärkeä - ja kenelle. Määrittelemme projektin tavoitteet ja sävyn. Dialogi alkaa tästä."
}, {
  id: "02",
  title: "Rakenne",
  description: "Suunnittelemme rakenteen, käsikirjoituksen ja toteutustavan. Rakennamme rungon, joka kantaa tarinaa alusta loppuun."
}, {
  id: "03",
  title: "Tuotanto",
  description: "Kuvaus, äänitys ja sisällön toteutus studiossa, tapahtumissa tai luonnon keskellä. Toteutamme projektin suunnitelman mukaisesti laadusta tinkimättä."
}, {
  id: "04",
  title: "Editointi",
  description: "Leikkaus, värimäärittely, äänisuunnittelu, miksaus ja viimeistely. Hiomme materiaalin selkeäksi ja vaikuttavaksi kokonaisuudeksi."
}, {
  id: "05",
  title: "Julkaisu",
  description: "Toimitamme materiaalin valmiina valittuihin kanaviin ja huolehdimme teknisestä laadusta. Tarvittaessa autamme myös julkaisussa ja käyttöönotossa."
}];
const ProcessStep = ({
  step,
  index,
  isLast
}: {
  step: (typeof steps)[0];
  index: number;
  isLast: boolean;
}) => {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: false,
    threshold: 0.5
  });
  return <div ref={ref as React.RefObject<HTMLDivElement>} data-index={index} className={cn("relative flex gap-8 md:gap-16 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-40")}>
      {}
      {!isLast && <div className={cn("absolute left-[2.5rem] md:left-[3.5rem] top-24 bottom-0 w-px border-l border-dashed transition-colors duration-700", isVisible ? "border-primary/50" : "border-border")} />}

      {}
      <div className="shrink-0">
        <span className={cn("block font-serif text-6xl md:text-8xl leading-none transition-colors duration-700", isVisible ? "text-primary" : "text-muted-foreground/20")}>
          {step.id}
        </span>
      </div>

      {}
      <div className="pb-24 pt-4 md:pt-8 max-w-xl">
        <h3 className={cn("text-2xl md:text-3xl font-medium mb-4 transition-colors duration-700", isVisible ? "text-primary" : "text-muted-foreground")}>
          {step.title}
        </h3>
        <p className={cn("font-mono text-sm md:text-base leading-relaxed transition-colors duration-700", isVisible ? "text-primary/90" : "text-muted-foreground")}>
          {step.description}
        </p>
      </div>
    </div>;
};
export default function PolkuIdeastaJulkaisuun() {
  return <section id="prosessi" className="text-foreground py-24 md:py-32 overflow-hidden bg-background dark">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {}
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <h2 className="text-4xl md:text-5xl font-serif mb-6 tracking-tight">
              Polku ideasta <br />
              <span className="text-muted-foreground italic">julkaisuun</span>
            </h2>
            <p className="text-muted-foreground font-mono text-sm max-w-xs border-l border-primary/20 pl-4">Jokainen tuotanto etenee selkeän prosessin kautta. Näin varmistamme, että lopputulos tukee tavoitteita, kertoo oikean tarinan ja toimii käytännössä.</p>
          </div>

          {}
          <div className="lg:col-span-8 lg:pl-12">
            <div className="flex flex-col">
              {steps.map((step, i) => <ProcessStep key={step.id} step={step} index={i} isLast={i === steps.length - 1} />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}